import { BitkitEmptyState, BitkitEmptyStateProps, IconErrorCircle } from '@bitrise/bitkit-v2';
import { Text } from '@chakra-ui/react/text';

type TestDataErrorStateProps = Pick<BitkitEmptyStateProps, 'children'> & { errorMessage: string };

export const TestDataErrorState = ({ children, errorMessage }: TestDataErrorStateProps) => (
  <BitkitEmptyState
    icon={IconErrorCircle}
    headingText="Can't load test results"
    bodyText={
      <Text as="span" display="block" marginBlockEnd="16">
        {errorMessage}
      </Text>
    }
  >
    {children}
  </BitkitEmptyState>
);
